import { useTranslation } from "react-i18next";
import { MailType } from "../../../models/Mail";
import { ConfirmationModal } from "../../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        type?: MailType;
    };
    onClose: () => void;
    deleteType: (type: MailType) => void
}

export const DeleteAgencyMailTypeModal: React.FC<Props> = ({
    info,
    onClose,
    deleteType
}) => {

    const { t } = useTranslation();

    const onDeleteType = () => {
        deleteType(info.type!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_MAIL_TYPE")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteType }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_MAIL_TYPE_MESSAGE', {name: info.type?.name})}
                </label>
            </div>
        </ConfirmationModal>
    )
}